$(function () {
fn_layout_header();
fn_layout_main();
fn_part_ui_cookies();
fn_part_ui_input();
fn_part_ui_number();
fn_part_ui_select();
fn_part_ui_wsw();
fn_comp_article();
fn_comp_hp_news();
fn_comp_visual();
});